
import TermsOfUse from '../../pages/termsOfUse/TermsOfUse';

export default function TermsModal({cancelModal}) {
 return (
    <div className="send-modal-overlay">
      <div className="send-modal">

        <TermsOfUse />
  
        <div className="send-modal-footer"></div>

        <button
          type="button"
          className="btn-close position-absolute top-0 end-0 m-3"
          aria-label="Close"
          onClick={cancelModal}
        ></button>

        <button onClick={cancelModal}>Close</button>
      </div>
    </div>
  );
}
